import { createStyles } from 'antd-style';
export var useStyles = createStyles(function () {
  return {
    description: {
      height: 32,
      marginLeft: 8,
      marginRight: 8,
      // marginLeft: 4,
      color: '#707275',
      display: 'inline-flex',
      alignItems: 'center',
      '& > span': {
        marginRight: 8,
        paddingRight: 8,
        position: 'relative',
        '&:not(:last-child):after': {
          content: "\"\"",
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
          width: 1,
          height: 16,
          backgroundColor: '#DBDDE0'
        }
      }
    }
  };
});